import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function PrintRoute() {
  const [content, setContent] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const storedContent = localStorage.getItem("printContent");
    if (storedContent) {
      setContent(storedContent);

      // Delay ensures content is rendered before printing
      setTimeout(() => {
        window.print();

        // After print, go back automatically
        setTimeout(() => {
          navigate(-1); // go back to previous page
        }, 500);
      }, 300);
    }
  }, [navigate]);

  return (
    <div dangerouslySetInnerHTML={{ __html: content }} />
  );
}
